import { CRITERIA, mapColors, SUB_TOTAL_ID } from './constant'

export const getCellColor = ({ schema, rowIndex, colIndex }) => {
  const rowLength = schema.yTicks.length
  const colLength = schema.xTicks.length

  return rowIndex > rowLength - 3 || colIndex > colLength - 3
    ? '#3A414B'
    : '#FFFFFF'
}

export const getCellBgColor = ({ schema, rowIndex, colIndex }) => {
  return (
    mapColors(schema.xTicks, schema.yTicks)?.[rowIndex]?.[colIndex] || '#F1F1F1'
  )
}

export const getLabelFromValue = (value) => {
  const item = Object.values(CRITERIA).find((item) => item.value === value)
  return item?.shortLabel || item?.label || ' '
}

const getCellData = (data = [], analyseId, versusId) => {
  return (
    data.find(
      (item) => item.analyseId === analyseId && item.versusId === versusId,
    ) || {}
  )
}

export const convertDataTable = (rawData) => {
  const xTicks =
    rawData.versusIndicators?.map((item) => ({
      ...item,
      value: item.name,
      tooltip: item.description,
    })) || []

  const yTicks =
    rawData.analyseIndicators?.map((item) => ({
      ...item,
      value: item.name,
      tooltip: item.description,
    })) || []

  const totalCompany = getCellData(
    rawData?.datas,
    SUB_TOTAL_ID,
    SUB_TOTAL_ID,
  )?.value

  const data =
    rawData.analyseIndicators?.map((analyseItem) =>
      rawData.versusIndicators?.map((versusItem) => {
        return {
          analyse: analyseItem,
          versus: versusItem,
          totalCompany,
          ...getCellData(rawData.datas, analyseItem.id, versusItem.id),
        }
      }),
    ) || []

  return {
    xTicks,
    yTicks,
    data,
  }
}
